<div class="split split-70 left">
  <header>
    <div class="main-header d-flex justify-content-between align-items-center">
      <div class="logo default-pointer" (click)="navigate()">
        <img src="../../assets/automapai-logo.png" class="header-termhub-logo" alt="AutomapAI" />
      </div>
    </div>
  </header>

  <div class="signup-body success-body">
    <div>
      <span class="header-text mb-3">Thank you for signing up for AutomapAI!</span>
    </div>
    <div class="input-text-font mt-3">
      <p>
        Organizations across healthcare increasingly face challenges with fragmented, inconsistent, and nonstandard clinical data. AutomapAI was
        designed to address these issues by accelerating semantic normalization and terminology mapping across standards such as SNOMEDCT, LOINC,
        ICD10CM, and RXNORM.
      </p>
      <p>
        We believe you will quickly see how AutomapAI can help simplify data standardization efforts and strengthen readiness for interoperability,
        analytics, and AI initiatives.
      </p>
      <p>
        Your trial account is limited to only “condition”, “medication”, and “labResult” entity types and you will be rate limited to 100 “term”
        requests per hour. Please avoid overloading the system as it is a demo/reference environment.
      </p>
      <p>
        Please <a class="form-link" href="https://youtu.be/P6glW9GUTNs" target="_blank">watch the overview video</a> and
        <a class="form-link" href="https://www.terminologyhub.com/automap" target="_blank">visit the AutomapAI page</a> to learn more about the
        platform.
      </p>
      <p>Thanks again for your interest, and welcome aboard.</p>
    </div>
    <div><a class="form-link back-link" [routerLink]="'/login'">Continue to Log In</a></div>
    <div class="split split-30 right tinted-image"></div>
  </div>
</div>
